import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import LazyLoad from 'react-lazyload'

import HomePage from '../pages/Home'
import AboutUsPage from '../pages/AboutUs'
import BoardOfDirectors from '../pages/BoardOfDirectors'
import ManagementTeam from '../pages/ManagementTeam'
import Header from '../Header/Header'
import Footer from '../components/Footer/Footer'
import OurCommitments from '../pages/OurCommitments'
import RiskManagement from '../pages/RiskManagement'
import OurPresence from '../pages/OurPresence'
import ContactUs from '../pages/ContactUs'
import FAQs from '../pages/FAQs'
import Partnership from '../pages/Partnership'
import MissionVision from '../pages/MissionVision'
import CorpGovernance from '../pages/CorpGovernance'
import ScrollToTop from '../components/ScrollToTop'
import Media from '../pages/Media'
// import Milestone from '../pages/Milestone'
import Interoperability from '../pages/Interoperability'
import UPI from '../pages/UPI'
import Rupay from '../pages/Rupay'
import Remittance from '../pages/Remittance'
import Infrastructure from '../pages/Infrastructure'
import FaqSection from '../components/FaqSection/FaqSection'
import EventsAwards from '../pages/EventsAwards'
// import Statistics from '../pages/Statistics'
// import ProductStatistics from '../pages/ProductStatistics'
import LegalPage from '../pages/LegalPage'
import LegalMarkdown from '../components/LegalMarkdown/LegalMarkdown'
import {
  EXISTING_PARTNERSHIP,
  INFRASTRUCTURE,
  INTEROPERABILITY,
} from '../Contansts'
import MediaPdfs from '../pages/MediaPdfs'
import KnowledgeCenter from '../pages/KnowledgeCenter'
import WhitePapers from '../pages/WhitePapers'
import CookiePopup from '../components/CookiePopup/CookiePopup'
import SafeBanking from '../pages/SafeBanking'
import Newsletter from '../pages/Newsletter'
import Sitemap from '../pages/Sitemap'
import Career from '../pages/Career'
// import Search from '../pages/Search'
// import Uptime from '../pages/Uptime'
import Head from '../components/Head/Head'
import ExistingPartnershipLayout from '../pages/ExistingPartnershipLayout'
import CSR from '../pages/CSR'
import Campaign from '../pages/Campaign'

function AppRouter() {
  return (
    <BrowserRouter>
      <Head />
      <Header />
      <div id="nav-cover"></div>
      <main className="mainContent">
        <Routes>
          <Route path="/" Component={HomePage} />
          <Route path="/about-us/who-we-are/" Component={AboutUsPage}>
            <Route path="vision-and-mission" Component={MissionVision} />
            <Route path="board-of-directors" Component={BoardOfDirectors} />
            <Route path="management-team" Component={ManagementTeam} />
            <Route path="global-presence" Component={OurPresence} />
            <Route path="csr" Component={CSR} />
          </Route>
          <Route path="/about-us/our-partners/" Component={Partnership}>
            <Route
              path={EXISTING_PARTNERSHIP}
              Component={ExistingPartnershipLayout}
            />
            <Route
              path={INFRASTRUCTURE}
              Component={ExistingPartnershipLayout}
            />
          </Route>
          <Route
            path="/about-us/risk-and-governance/"
            Component={OurCommitments}
          >
            <Route path="corporate-governance" Component={CorpGovernance} />
            <Route path="risk-management" Component={RiskManagement} />
          </Route>
          <Route
            path={`/how-it-works/${INTEROPERABILITY}/`}
            Component={Interoperability}
          >
            <Route path="upi" Component={UPI}></Route>
            <Route path="rupay" Component={Rupay}></Route>
            <Route path="remittances" Component={Remittance}></Route>
          </Route>
          <Route
            path={`/how-it-works/${INFRASTRUCTURE}/`}
            Component={Infrastructure}
          >
            <Route path="upi" Component={UPI}></Route>
            <Route path="rupay" Component={Rupay}></Route>
          </Route>
          <Route
            path="/how-it-works/frequently-asked-questions/"
            Component={FAQs}
          >
            <Route path="upi" Component={FaqSection} />
            <Route path="rupay" Component={FaqSection} />
            <Route path="remittances" Component={FaqSection} />
            <Route path="upipaynow" Component={FaqSection} />
          </Route>
          <Route path="/media-and-coverage/" Component={Media}>
            <Route path="press-releases" Component={MediaPdfs} />
            <Route path="media-coverage" Component={MediaPdfs} />
            <Route path="events-and-awards" Component={EventsAwards} />
            <Route path="knowledge-center" Component={KnowledgeCenter}>
              <Route path="whitepapers" Component={WhitePapers} />
              <Route path="safe-banking" Component={SafeBanking} />
              <Route path="newsletter" Component={Newsletter} />
            </Route>
            <Route path="digital-media-kit" Component={MediaPdfs} />
          </Route>
          {/* <Route
            path="/statistics-and-milestones/key-milestones"
            Component={Milestone}
          /> */}

          {/* Uncomment the route whenever client wants the product statistics page
          <Route
            path="/statistics-and-milestones/statistics/"
            Component={Statistics}
          >
            <Route path="product-statistics" Component={ProductStatistics} />
            <Route path="uptime" Component={Uptime} />
          </Route> */}
          <Route path="/get-in-touch/contact-us" Component={ContactUs} />
          <Route path="/get-in-touch/career" Component={Career} />
          <Route path="/legal/" Component={LegalPage}>
            <Route path="terms-of-use" Component={LegalMarkdown} />
            <Route path="privacy-policy" Component={LegalMarkdown} />
            <Route path="cookie-policy" Component={LegalMarkdown} />
          </Route>
          <Route path="/sitemap" Component={Sitemap} />
          {/* <Route path="/search/:id" Component={Search} /> */}
          <Route path="/pages/:slug" Component={Campaign} />
          {/* Campaign page short route for sms requirement */}
          <Route path="/c" Component={Campaign} />
          <Route path="*" Component={HomePage} />
        </Routes>
      </main>
      <ScrollToTop />
      <CookiePopup />
      <LazyLoad offset={10}>
        <Footer />
      </LazyLoad>
    </BrowserRouter>
  )
}

export default AppRouter
